// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__w6DVM","text":"styles_text__ajrpI","illustration":"styles_illustration__Uf7eu"};